import { isConsumer } from "owa-session-store";
import { getApplicationSettings } from "owa-application-settings";
import type { MailboxInfo } from "owa-client-types";

export default function getPrivacyUrl(mailboxInfo?: MailboxInfo): string {
    const feedbackSettings = getApplicationSettings("Feedback", mailboxInfo);
    return isConsumer()
        ? feedbackSettings.consumerPrivacyUrl
        : feedbackSettings.enterprisePrivacyUrl;
}
